import { useCallback, useEffect, useState } from 'react';
import { supabase } from '../../../lib/supabase';
import { useAuth } from '../../../contexts/AuthContext';

/** Partner earned free CRM via paying referral (RLS: own row only). */
export function usePartnerCrmGrant(): boolean {
  const { user } = useAuth();
  const [granted, setGranted] = useState(false);

  const load = useCallback(async () => {
    if (!user?.id) {
      setGranted(false);
      return;
    }
    const { data, error } = await supabase
      .from('partners')
      .select('crm_access_granted')
      .eq('user_id', user.id)
      .maybeSingle();

    if (error) {
      console.warn('[usePartnerCrmGrant]', error.message);
      setGranted(false);
      return;
    }
    setGranted(Boolean(data?.crm_access_granted));
  }, [user?.id]);

  useEffect(() => {
    void load();
  }, [load]);

  return granted;
}
